import React from "react";
import { cn } from "@/lib/utils";
import { formatPercent, formatCount } from "@/lib/format";

/**
 * Target-vs-achieved badge.
 *  >= 100%   -> success
 *  90-100%   -> warning
 *  < 90%     -> danger
 */
export function TargetBadge({ actual = 0, target = 0, showValues = false, testId, className }) {
  if (!target) {
    return <span className={cn("inline-flex items-center rounded-full border bg-[hsl(var(--surface-2))] px-2 py-0.5 text-xs text-muted-foreground", className)} data-testid={testId}>—</span>;
  }
  const ratio = actual / target;
  const tone = ratio >= 1 ? "success" : ratio >= 0.9 ? "warning" : "danger";
  const cls = {
    success: "bg-[hsl(var(--success)/0.12)] text-[hsl(var(--success))] border-[hsl(var(--success)/0.25)]",
    warning: "bg-[hsl(var(--warning)/0.12)] text-[hsl(var(--warning))] border-[hsl(var(--warning)/0.25)]",
    danger: "bg-[hsl(var(--danger)/0.12)] text-[hsl(var(--danger))] border-[hsl(var(--danger)/0.25)]",
  }[tone];
  return (
    <span data-testid={testId} className={cn("inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium tabular-nums", cls, className)}>
      {formatPercent(ratio, 0)}
      {showValues && <span className="opacity-70">({formatCount(actual)}/{formatCount(target)})</span>}
    </span>
  );
}
